"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const lodash_1 = __importStar(require("lodash"));
const react_redux_1 = require("react-redux");
const qs_1 = __importDefault(require("qs"));
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const ReviewNotificationOptionComponent_1 = __importDefault(require("../../../../../reviews/components/ReviewNotificationOptionComponent"));
const ReviewStageAccordion_1 = __importDefault(require("../../../../../reviews/components/ReviewStagesDetail/ReviewStageAccordion"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const sliceReview_1 = require("../../../../slice/sliceReview");
const store_1 = require("../../../../store");
const helper_1 = require("../../../../../reviews/helper");
const selectors_1 = __importDefault(require("../../../../slice/selectors"));
const defaultData_1 = require("../defaultData");
const notification_1 = __importDefault(require("../../../../../reviews/constants/notification"));
const PERMISSIONS = ['view', 'comment', 'decision', 'manage'];
const DEFAULT_URL = `/v2/ajax/address-book/users`;
const MACCESS = ['Admin', 'Superuser', 'Local admin', 'Invite-only'];
const queryParamsAccess = qs_1.default.stringify({
    maccess: MACCESS,
}, { arrayFormat: 'brackets', addQueryPrefix: true });
const MIN_CHARACTERS = 3;
const MAX_HEIGHT_DROPDOWN_DEFAULT = ((_a = document === null || document === void 0 ? void 0 : document.documentElement) === null || _a === void 0 ? void 0 : _a.clientHeight) / 7;
const ReviewStage = ({ stage, indexStage, setOpenRemoveStageModal, setTriggerStateModal, formikProps, }) => {
    var _a;
    const { roundStages, round, amountOwner, defaultNotification, defaultStatusCalculation, } = (0, react_redux_1.useSelector)(selectors_1.default);
    const { errors } = formikProps;
    const [exceptUsersParamUrl, setExceptUsersParamUrl] = (0, react_1.useState)('');
    const [maxHeightSelect, setMaxHeightSelect] = (0, react_1.useState)(MAX_HEIGHT_DROPDOWN_DEFAULT);
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const resizeHeightDropdown = (event) => {
        const target = event === null || event === void 0 ? void 0 : event.target;
        if (target === null || target === void 0 ? void 0 : target.innerHeight) {
            setMaxHeightSelect((target === null || target === void 0 ? void 0 : target.innerHeight) / 7);
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', resizeHeightDropdown, true);
        return () => {
            window.removeEventListener('resize', (event) => {
                const target = event === null || event === void 0 ? void 0 : event.target;
                if (target === null || target === void 0 ? void 0 : target.innerHeight) {
                    setMaxHeightSelect((target === null || target === void 0 ? void 0 : target.innerHeight) / 7);
                }
            }, true);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = stage.members) === null || _a === void 0 ? void 0 : _a.length) {
            const params = {
                'except-users': stage.members.map((user) => user.id || user.userid),
            };
            const exceptUsersParam = qs_1.default.stringify(params);
            setExceptUsersParamUrl(exceptUsersParam);
        }
    }, [stage.members]);
    const validStageReviewers = () => {
        var _a, _b, _c;
        if (errors === null || errors === void 0 ? void 0 : errors.stages) {
            if ((_a = errors === null || errors === void 0 ? void 0 : errors.stages[indexStage]) === null || _a === void 0 ? void 0 : _a.reviewers) {
                return (0, lodash_1.isString)((_b = errors === null || errors === void 0 ? void 0 : errors.stages[indexStage]) === null || _b === void 0 ? void 0 : _b.reviewers);
            }
            return !!((_c = errors === null || errors === void 0 ? void 0 : errors.stages[indexStage]) === null || _c === void 0 ? void 0 : _c.reviewers);
        }
        return false;
    };
    const dispatchUpdateRoundStage = (valueUpdate) => {
        dispatch((0, sliceReview_1.updateRoundStage)({
            indexStage,
            valueUpdate,
        }));
    };
    (0, react_1.useEffect)(() => {
        dispatch((0, sliceReview_1.updateAmountOwner)());
    }, [stage]);
    const [users, setUsers] = (0, react_1.useState)([]);
    const isDisablePermission = (permission, userId) => {
        if (permission === 'view') {
            return true;
        }
        if (round) {
            // disable manager for owner and current user
            if (permission === 'manage' && userId === (round === null || round === void 0 ? void 0 : round.ownerId)) {
                return true;
            }
        }
        return false;
    };
    const handleChangeMadeDecision = (indexUser = 0) => {
        if ((stage === null || stage === void 0 ? void 0 : stage.members) && (stage === null || stage === void 0 ? void 0 : stage.stageStatusStrategy)) {
            const strategyCurrent = stage === null || stage === void 0 ? void 0 : stage.stageStatusStrategy;
            const userCurrent = stage === null || stage === void 0 ? void 0 : stage.members[indexUser];
            const userCurrentId = (userCurrent === null || userCurrent === void 0 ? void 0 : userCurrent.id) || (userCurrent === null || userCurrent === void 0 ? void 0 : userCurrent.userid);
            const strategyUserCurrentId = strategyCurrent === null || strategyCurrent === void 0 ? void 0 : strategyCurrent.userId;
            if (strategyUserCurrentId === userCurrentId) {
                dispatchUpdateRoundStage({
                    stageStatusStrategy: defaultStatusCalculation,
                });
            }
        }
    };
    const handleRemoveModal = () => {
        if ((0, lodash_1.isFunction)(setOpenRemoveStageModal)) {
            setOpenRemoveStageModal({
                open: true,
                index: indexStage,
                stageName: stage.nameStage,
            });
        }
    };
    const handleChangeAccordion = (expanded) => {
        dispatchUpdateRoundStage({
            isOpen: expanded,
        });
    };
    const handlePermission = (e, indexUser, permission, userId) => {
        if (!isDisablePermission(permission, userId)) {
            const newMembers = stage.members && [...stage.members];
            const newPermissionMember = newMembers && { ...newMembers[indexUser] };
            if (newPermissionMember) {
                newPermissionMember[permission] = e.target.checked;
                newMembers[indexUser] = newPermissionMember;
            }
            dispatchUpdateRoundStage({
                members: newMembers,
            });
        }
        // handle made decision by people when un-check decision
        if (!e.target.checked && permission === 'decision') {
            handleChangeMadeDecision(indexUser);
        }
    };
    const handleUsers = (value) => {
        setUsers(value.userId);
    };
    const handleAddUsers = (0, react_1.useCallback)(async () => {
        var _a;
        let manage = false;
        if (!lodash_1.default.isEmpty(users)) {
            const newUsers = users.map(async (user) => {
                var _a, _b, _c, _d, _e;
                manage = (user === null || user === void 0 ? void 0 : user.value) === (round === null || round === void 0 ? void 0 : round.ownerId);
                try {
                    if (user === null || user === void 0 ? void 0 : user.__isNew__) {
                        utilities_1.default.blockPage();
                        const res = await pulse_components_1.v2Endpoint.request({
                            method: pulse_components_1.METHODS.POST,
                            url: `${helper_1.URLS.app}ajax/address-book/users/0`,
                            data: {
                                user_name: user.value,
                                user_email: user.value,
                                is_non_client: true,
                                is_ziflow: true,
                                access: 'suspended',
                                category: 'Client',
                                languageid: helper_1.USER.languageid,
                            },
                            headers: {
                                'Content-Type': 'application/vnd.api+json',
                                Accept: 'application/vnd.api+json',
                            },
                        });
                        utilities_1.default.unblockPage();
                        const newUserId = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userid;
                        return {
                            email: user.value,
                            name: user.value,
                            userid: newUserId,
                            ...defaultData_1.INITIAL_MEMBER,
                            manage,
                            roundStageNotificationType: defaultNotification,
                        };
                    }
                }
                catch (error) {
                    const errorMessage = (_e = (_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : 'Error when adding user';
                    utilities_1.default.notification.danger(errorMessage);
                    utilities_1.default.unblockPage();
                }
                return {
                    ...user.raw,
                    ...defaultData_1.INITIAL_MEMBER,
                    manage,
                    roundStageNotificationType: defaultNotification,
                };
            });
            const reviewers = await Promise.all(newUsers);
            const validReviewers = reviewers.filter((reviewer) => reviewer.userid);
            // check existing reviewer when added new reviewers
            const countOldReviewer = ((_a = stage.members) === null || _a === void 0 ? void 0 : _a.length) || 0;
            const countNewReviewer = (validReviewers === null || validReviewers === void 0 ? void 0 : validReviewers.length) || 0;
            const totalNewReviewer = countOldReviewer + countNewReviewer;
            const realReviewers = (stage.members &&
                (0, lodash_1.uniqBy)([...stage.members, ...validReviewers], (member) => member.id || member.userid)) ||
                [];
            if (totalNewReviewer > realReviewers.length) {
                utilities_1.default.notification.warning(notification_1.default.existedEmail);
            }
            dispatchUpdateRoundStage({
                members: realReviewers,
            });
        }
        setUsers([]);
    }, [users]);
    const handleChangeName = (newName) => {
        dispatchUpdateRoundStage({
            nameStage: newName,
        });
    };
    const handleRemoveUser = (indexUser) => {
        const newUsers = stage.members && [...stage.members];
        if (newUsers) {
            (0, lodash_1.remove)(newUsers, (user, index) => index === indexUser);
        }
        dispatchUpdateRoundStage({
            members: newUsers,
        });
    };
    const handleChangeNotification = (value, indexUser) => {
        const newMembers = stage.members && [...stage.members];
        const newNotificationMember = newMembers && { ...newMembers[indexUser] };
        if (newNotificationMember) {
            newNotificationMember.roundStageNotificationType = value;
            newMembers[indexUser] = newNotificationMember;
        }
        dispatchUpdateRoundStage({
            members: newMembers,
        });
    };
    const canRemoveStage = () => {
        var _a;
        if (amountOwner > 1) {
            return true;
        }
        if (roundStages.length > 1) {
            // exist Owner in current stage
            const existOwner = (_a = stage.members) === null || _a === void 0 ? void 0 : _a.some((member) => (member.id || member.userid) === (round === null || round === void 0 ? void 0 : round.ownerId));
            // if we don't have any member in this stage, we still can remove it
            if (existOwner === undefined) {
                return true;
            }
            return !existOwner;
        }
        return false;
    };
    const urlUserStage = `${DEFAULT_URL}${queryParamsAccess}&${exceptUsersParamUrl}`;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ReviewStageAccordion_1.default, { stage: stage, isEdit: true, handleRemoveStage: canRemoveStage() ? handleRemoveModal : undefined, onChange: handleChangeAccordion, handleChangeName: handleChangeName, stageIndex: indexStage, setTriggerStateModal: setTriggerStateModal }, (_a = stage.members) === null || _a === void 0 ? void 0 :
            _a.map((user, indexUser) => {
                var _a;
                const userId = Number((user === null || user === void 0 ? void 0 : user.id) || (user === null || user === void 0 ? void 0 : user.userid));
                const validStageNotificationType = () => {
                    var _a, _b;
                    const errorStage = errors === null || errors === void 0 ? void 0 : errors.stages;
                    if (errorStage) {
                        const errorReviewer = (_a = errorStage[indexStage]) === null || _a === void 0 ? void 0 : _a.reviewers;
                        return errorReviewer
                            ? !!((_b = errorReviewer[indexUser]) === null || _b === void 0 ? void 0 : _b.notification_type_id)
                            : false;
                    }
                    return false;
                };
                return (react_1.default.createElement("div", { key: userId, className: (0, clsx_1.default)(styles_modules_less_1.default['stage-reviews'], 'stage-reviews') },
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-reviews__user'] },
                        react_1.default.createElement("img", { src: `${((_a = user.avatarUrl) === null || _a === void 0 ? void 0 : _a.includes(helper_1.USER_AVATAR))
                                ? user.avatarUrl
                                : `${helper_1.USER_AVATAR}${user.avatarUrl}`}`, alt: user.name, className: styles_modules_less_1.default['stage-reviews__user--avatar'] }),
                        react_1.default.createElement("span", { className: styles_modules_less_1.default['stage-reviews__user--name'] }, user.name),
                        userId === (round === null || round === void 0 ? void 0 : round.ownerId) && (react_1.default.createElement(pulse_components_1.PulseChip, { classes: {
                                root: styles_modules_less_1.default['stage-reviews__user--role'],
                            }, label: "Review Author" }))),
                    react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-reviews__permission'] },
                        react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-reviews__permission--list'] }, Object.entries(user)
                            .filter((item) => PERMISSIONS.includes(item[0]))
                            .map((permission) => {
                            const permissionLabel = permission[0];
                            const canPermission = permission[1];
                            return (react_1.default.createElement("div", { key: permissionLabel, className: styles_modules_less_1.default['stage-reviews__permission--item'] },
                                react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(pulse_components_1.PulseCheckBox, { name: `${permissionLabel}${indexUser}${indexStage}`, label: permissionLabel, labelPlacement: "right", showLabel: true, className: [
                                            styles_modules_less_1.default.permission__icon,
                                            (0, clsx_1.default)(isDisablePermission(permissionLabel, userId) && styles_modules_less_1.default['permission__icon--disable']),
                                        ], labelClasses: (0, clsx_1.default)(styles_modules_less_1.default['stage-reviews__permission--label'], isDisablePermission(permissionLabel, userId) &&
                                            styles_modules_less_1.default['stage-reviews__permission-label--disable']), checked: canPermission, onClick: (e) => {
                                            handlePermission(e, indexUser, permissionLabel, userId);
                                        } }))));
                        })),
                        react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-reviews__permission--notify'] },
                            react_1.default.createElement(ReviewNotificationOptionComponent_1.default, { value: user.roundStageNotificationType, handleChange: (value) => handleChangeNotification(value, indexUser), labelName: "Notification Options", isInvalid: validStageNotificationType() }))),
                    react_1.default.createElement("i", { onClick: () => handleRemoveUser(indexUser), className: (0, clsx_1.default)('fal fa-trash-alt', styles_modules_less_1.default['stage-reviews__removeIcon']) })));
            }),
            react_1.default.createElement("div", { className: styles_modules_less_1.default['add-users'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['add-users__root'] },
                    react_1.default.createElement(pulse_components_1.PulseProjectUsersSelect, { key: maxHeightSelect, labelName: '', classes: {
                            root: styles_modules_less_1.default['add-users__root--input'],
                            menu: {
                                menuCtn: styles_modules_less_1.default['add-users__root--menu'],
                            },
                        }, variant: "select2", isMulti: true, isCreatable: true, value: users, placeholder: "Enter the name of a user to add to the review", valueChangeHandler: handleUsers, insideModal: true, isInvalid: validStageReviewers(), url: `${urlUserStage}`, isClearable: false, cacheUniqs: [`${urlUserStage}`], minCharacters: MIN_CHARACTERS, maxMenuHeight: maxHeightSelect, TippyProps: {
                            placement: 'bottom',
                            popperOptions: {
                                modifiers: [
                                    {
                                        name: 'flip',
                                        enabled: false,
                                    },
                                ],
                            },
                        } }),
                    react_1.default.createElement(pulse_components_1.PulseButton, { classes: [styles_modules_less_1.default['add-users__btn']], icon: true, color: pulse_components_1.Colors.default, variant: pulse_components_1.ButtonVariants.outlined, iconClasses: {
                            icon: 'fal fa-plus',
                            root: styles_modules_less_1.default['add-users__icon'],
                        }, onClick: handleAddUsers, label: "Add user to stage" }))))));
};
exports.default = ReviewStage;
